import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory, Route } from 'react-router-dom';
import { Button, Card, Page, Typography } from 'seagull';
import { routes } from '~/constants';
import { useSetDocumentTitle } from '~/hooks/useSetDocumentTitle';
import { useLocaleKeys } from '~/i18n';
import { useIoContext } from '~/providers/IoContext';
import { ActiveServicesReport } from './ActiveServices/ActiveServices';
import { FutureInvoicesReport } from './FutureInvoices/FutureInvoices';
import { ProposalsReport } from './ProposalsReport/ProposalsReport';
import { RemainingCreditReport } from './RemainingCredit/RemainingCredit';
import styles from './Reports.module.scss';
import { RevenueBreakdownReport } from './RevenueBreakdown/RevenueBreakdown';
const ReportCard = (props)=>{
    const { title, description, url, testId, goToReportLabel } = props;
    const history = useHistory();
    return /*#__PURE__*/ _jsxs(Card, {
        bi: {
            name: 'report_card',
            data: {
                report_title: title
            }
        },
        className: styles.reportCard,
        autoHeight: true,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.reportCardDetails,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        weight: "bold",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'open_report',
                        data: {
                            report: testId
                        }
                    },
                    testId: "report-card-".concat(testId, "-navigate"),
                    onClick: ()=>history.push(url),
                    children: goToReportLabel
                })
            })
        ]
    });
};
const AllReports = ()=>{
    const { t: reportsTexts } = useLocaleKeys('pages.reports');
    useSetDocumentTitle(reportsTexts.documentTitle());
    const goToReportLabel = reportsTexts.goToReport();
    return /*#__PURE__*/ _jsxs(Page, {
        header: reportsTexts.pageHeader(),
        testId: "all-reports-screen",
        children: [
            /*#__PURE__*/ _jsx(ReportCard, {
                title: reportsTexts.revenueBreakdown.title(),
                description: reportsTexts.revenueBreakdown.description(),
                url: routes.revenueReport,
                testId: "revenue",
                goToReportLabel: goToReportLabel
            }),
            /*#__PURE__*/ _jsx(ReportCard, {
                title: reportsTexts.activeServices.title(),
                description: reportsTexts.activeServices.description(),
                url: routes.activeServicesReport,
                testId: "active-services",
                goToReportLabel: goToReportLabel
            }),
            /*#__PURE__*/ _jsx(ReportCard, {
                title: reportsTexts.futureInvoices.title(),
                description: reportsTexts.futureInvoices.description(),
                url: routes.futureInvoicesReport,
                testId: "future-invoices",
                goToReportLabel: goToReportLabel
            }),
            /*#__PURE__*/ _jsx(ReportCard, {
                title: reportsTexts.sentProposals.title(),
                description: reportsTexts.sentProposals.description(),
                url: routes.proposalsReport,
                testId: "sent-proposals",
                goToReportLabel: goToReportLabel
            }),
            /*#__PURE__*/ _jsx(ReportCard, {
                title: reportsTexts.remainingCredit.title(),
                description: reportsTexts.remainingCredit.description(),
                url: routes.remainingCreditReport,
                testId: "remaining-credit",
                goToReportLabel: goToReportLabel
            })
        ]
    });
};
export const Reports = (param)=>{
    let { now } = param;
    const { getNow } = useIoContext();
    const nowValue = now !== null && now !== void 0 ? now : getNow();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Route, {
                path: routes.reports,
                exact: true,
                render: ()=>/*#__PURE__*/ _jsx(AllReports, {})
            }, "all-reports"),
            /*#__PURE__*/ _jsx(Route, {
                path: routes.revenueReport,
                exact: true,
                render: ()=>/*#__PURE__*/ _jsx(RevenueBreakdownReport, {
                        now: nowValue
                    })
            }, "revenue-report"),
            /*#__PURE__*/ _jsx(Route, {
                path: routes.activeServicesReport,
                exact: true,
                render: ()=>/*#__PURE__*/ _jsx(ActiveServicesReport, {})
            }, "active-services-report"),
            /*#__PURE__*/ _jsx(Route, {
                path: routes.futureInvoicesReport,
                exact: true,
                render: ()=>/*#__PURE__*/ _jsx(FutureInvoicesReport, {})
            }, "future-invoices-report"),
            /*#__PURE__*/ _jsx(Route, {
                path: routes.proposalsReport,
                exact: true,
                render: ()=>/*#__PURE__*/ _jsx(ProposalsReport, {
                        now: nowValue
                    })
            }, "proposals-report"),
            /*#__PURE__*/ _jsx(Route, {
                path: routes.remainingCreditReport,
                exact: true,
                render: ()=>/*#__PURE__*/ _jsx(RemainingCreditReport, {})
            }, "remaining-credit-report")
        ]
    });
};
